import React, { useState } from 'react';
import OneTour from './OneTour';
import formatNumber from '../utils/formatNumber';

const OneGroupByRoomTours = ({
  row,
  room,
  hideoperator = false,
  geoclient,
  row_fix,
  onAction,
  setOpenModal,
  setTourToShare,
  groupedTours,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <div className="tours__group-header" onClick={() => setIsOpen(!isOpen)}>
        <div style={{ paddingRight: '120px' }}>
          {room} ({groupedTours[room].length})
        </div>{' '}
        <span
          style={{
            position: 'absolute',
            right: '10px',
            top: '10px',
            fontWeight: 'bold',
          }}
        >
          от {formatNumber(groupedTours[room][0].price)}{' '}
          {groupedTours[room][0].currency === 'RUB'
            ? `₽`
            : groupedTours[room][0].currency}
        </span>
      </div>
      {isOpen ? (
        <div className="hotel_hidden_list1">
          {groupedTours[room].map((tour) => (
            <OneTour
              key={`group-${tour.tourid}`}
              row_fix={row_fix}
              row={row}
              hideoperator={hideoperator}
              geoclient={geoclient}
              onAction={onAction}
              tour={tour}
              setOpenModal={setOpenModal}
              setTourToShare={setTourToShare}
            />
          ))}
        </div>
      ) : null}
    </>
  );
};

export default OneGroupByRoomTours;
